import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import { 
  ContractUserResponse, 
  ContractUserSaveRequest, 
  ContractStatus 
} from "../types/ContractUser";

const baseUrl = '/api/ContractManagement';

export const getContractUsers = async (addressSystemId: number, contractStatusId: number): Promise<ContractUserResponse> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get(`${baseUrl}/getContractUsersForManagement`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      addressSystemId,
      contractStatusId
    }
  });
  return response.data as ContractUserResponse;
};

export const saveContractUsers = async (request: ContractUserSaveRequest): Promise<void> => {
  const token = await getApiAccessToken();
  await apiClient.post(`${baseUrl}/saveContractUsers`, request, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getContractStatuses = async (addressSystemId: number): Promise<ContractStatus[]> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get(`${baseUrl}/contract-statuses/${addressSystemId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data as ContractStatus[];
};


